<template>
  <button
    type="button"
    class="eraser-tool-button"
    :class="{ active: expanded }"
    :disabled="disabled"
    :title="$t(mode === 'erase' ? 'editor.eraserTools' : 'editor.repairBrush')"
    :aria-label="$t(mode === 'erase' ? 'editor.eraserTools' : 'editor.repairBrush')"
    :aria-pressed="expanded"
    :aria-expanded="expanded"
    @click.stop="$emit('open', mode)"
  >
    <svg width="28" height="28" viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <template v-if="mode === 'erase'">
        <path d="M7.2 20.8 18.8 7.4a2 2 0 0 1 2.9-.2l5.1 4.5a2 2 0 0 1 .2 2.9L16.4 26H11l-3.7-3.2a1.5 1.5 0 0 1-.1-2z" />
        <path d="m14.4 12.7 8.1 7.1M11 26h15" />
      </template>
      <g v-else transform="rotate(-45 16 16)">
        <rect x="3" y="10" width="26" height="12" rx="4" />
        <path d="M11 10v12M21 10v12" />
        <path d="M15 14h.01M18 14h.01M15 18h.01M18 18h.01M7 14h.01M7 18h.01M25 14h.01M25 18h.01" stroke-width="2.5" />
      </g>
    </svg>
  </button>
</template>

<script>
export default {
  name: 'EraserToolsButton',
  props: {
    mode: { type: String, default: 'erase' },
    disabled: { type: Boolean, default: false },
    expanded: { type: Boolean, default: false }
  },
  emits: ['open']
};
</script>

<style scoped>
.eraser-tool-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  padding: 0;
  border: 0;
  background: transparent;
  border-radius: 8px;
  color: #26374e;
  cursor: pointer;
  flex-shrink: 0;
  touch-action: manipulation;
}

.eraser-tool-button.active {
  background: #e8f0fc;
  color: #55768f;
}

.eraser-tool-button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.eraser-tool-button:focus-visible {
  outline: 2px solid #55768f;
}
</style>